/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// console.log('Hello World from Webpacker');
// Support component names relative to this directory:

import "core-js/stable";
import "regenerator-runtime/runtime";
import 'babel-polyfill';

const componentRequireContext = require.context('components', false);
const ReactRailsUJS = require('react_ujs');

ReactRailsUJS.useContext(componentRequireContext);

/*
var ReactRailsUJS = require("react_ujs");


// Start with an empty list of require contexts:
ReactRailsUJS.requireContexts = []

// attach the ujs to the global namespace so that later bundles can access it:
window.ReactRailsUJS = ReactRailsUJS


// Implement `getConstructor` to try _each_ requireContext:
ReactRailsUJS.getConstructor = function(className) {
    var contextLength = ReactRailsUJS.requireContexts.length
    var requireContext
    var constructor
    for (var i = 0; i < contextLength; i++) {
        // Try each context:
        requireContext = ReactRailsUJS.requireContexts[i]
        try {
            // Look up the classname in this context:
            constructor = requireContext("./" + className + ".js")
            // If there wasn't an error, we found it:
            return constructor  // TODO: normalize the exported module
        } catch (err) {
            // It wasn't in this context
        }
        // Failed to find the constructor at all:
        throw new Error("Couldn't find " + className + " in any requireContext")
    }
}
*/
